'use client';

import type { Message } from '@repo/api';
import { AppointmentSlotsCard } from './AppointmentSlotsCard';
import { StarRatingCard } from './StarRatingCard';

interface MultipleChoiceCardProps {
  message: Message;
  onSlotSelect: (value: string, message: Message) => void;
}

export function MultipleChoiceCard({ message, onSlotSelect }: MultipleChoiceCardProps) {
  switch (message.displayType) {
    case 'rating':
      return <StarRatingCard message={message} onSlotSelect={onSlotSelect} />;

    case 'appointment_slots':
      return <AppointmentSlotsCard message={message} onSlotSelect={onSlotSelect} />;
    default:
      return null;
  }
}
